// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__-loca-__3dgUo","load2":"Spinner__-loca-__1sg5x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 124
// module chunks = 0